export default [
    {
        path: '/menu/create',
        name: 'FoodMenu_Create',
        component: () => import('@/views/reservation/menu/create.vue'),
        meta: {
            authRequired: true,
            permission: 'food-menus.index'
        }
    },
    {
        path: '/reservation',
        name: 'Reservation',
        component: () => import('@/views/reservation/index.vue'),
        meta: {
            authRequired: true,
            permission: 'reservations.index'
        }
    },
    {
        path: '/reservation/special',
        name: 'Reservation_Special',
        component: () => import('@/views/reservation/special.vue'),
        meta: {
            authRequired: true,
            permission: 'special-reservations.index'
        }
    },
    {
        path: '/reservation/report',
        name: 'Reservation_Report',
        component: () => import('@/views/reservation/report.vue'),
        meta: {
            authRequired: true,
            permission: 'reservations.report'
        }
    },
]
